import React from 'react';

const ProtectedImage = ({ 
  src, 
  alt, 
  className = '', 
  style = {},
  imgStyle = {},
  onLoad,
  onError,
  ...props 
}) => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const imgRef = React.useRef(null);

  const handleLoad = (e) => {
    setIsLoaded(true);
    if (onLoad) onLoad(e);
  };

  const handleError = (e) => {
    if (onError) onError(e);
  };

  const handleRightClick = (e) => {
    e.preventDefault();
    return false;
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    ...style
  };

  const imageStyle = {
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    WebkitUserDrag: 'none',
    MozUserDrag: 'none',
    userDrag: 'none',
    pointerEvents: 'none',
    width: '100%',
    height: 'auto',
    ...imgStyle
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.05) 50%, transparent 70%)',
    pointerEvents: 'none',
    zIndex: 1
  };

  return (
    <div 
      style={containerStyle}
      onContextMenu={handleRightClick}
      onDragStart={handleDragStart}
      className={`protected-image-container ${className}`}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        style={imageStyle}
        onLoad={handleLoad}
        onError={handleError}
        onContextMenu={handleRightClick}
        onDragStart={handleDragStart}
        {...props}
      />
      
      {isLoaded && (
        <>
          <div style={overlayStyle} />
        </>
      )}
    </div>
  );
};

export default ProtectedImage;